module.exports = __webpack_public_path__ + "static/img/firelogdemo.b25b5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/firelogdemo.png
// module id = 426
// module chunks = 1